import { render } from "./UserPositionCard.vue?vue&type=template&id=40862fa2&scoped=true"
import script from "./UserPositionCard.vue?vue&type=script&lang=js"
export * from "./UserPositionCard.vue?vue&type=script&lang=js"

import "./UserPositionCard.vue?vue&type=style&index=0&id=40862fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40862fa2"]])

export default __exports__